export default __webpack_public_path__ + "static/media/favourite-place.1bfb7823.jpg";